@if (user) {
    <div class="animated fadeIn name-container">
        <div class="container px-4 px-lg-3">
            <div class="d-flex align-items-center justify-content-between mt-lg-5 px-0 px-md-3 px-lg-0 py-4 pt-lg-0 pb-lg-3">
                <p class="fw-sbold cl-black fs-20 text-start mb-0">Hola, {{ formatName(user?.name) || '' }}</p>
                <p class="cl-black fw-light fs-12 text-end mb-0">Último inicio de sesión <br class="d-block d-md-none"> {{ user?.lastSession || dateNow | date: 'dd/MM/YY HH:mm'}}</p>       
            </div>
        </div>
        @if (actualStatusUser.isInvestor || actualStatusUser?.hasSpoIn) {
            <mnf-dashboard-v2-investors [user]="user" [step]="user.stepRegister" [status]="actualStatusUser"></mnf-dashboard-v2-investors>
        } @else if (!actualStatusUser.isInvestor) {
            <mnf-dashboard-v2-no-investors [step]="user.stepRegister" [status]="actualStatusUser"></mnf-dashboard-v2-no-investors>
        }
    </div>
}